module.exports = __webpack_public_path__ + "img/shake_top.f66c98d1.png";